module.exports = __webpack_public_path__ + "static/logo-white-sk-731fa69a5f939d84a5b7bcde6422f4ee.png";